import React from 'react';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
import { TEMPORARY_TECHNICAL_ERROR } from '@src/constants/messages';

/**
 * The transient-failure alert for a call the customer retries in place by
 * pressing Continue again.
 *
 * Distinct from ErrorBanner, which says the same thing plus a support number
 * and belongs to the page-load eligibility failure — that one the customer
 * cannot retry, so it gives them somewhere to turn. Using it here would tell a
 * customer to phone about something a second press of Continue would fix.
 */
const TechnicalErrorAlert = () => (
  <div className="sui-mb-4" data-testid="technical-error-alert">
    <Alert status="error" size="large">
      <Typography variant="body-base">{TEMPORARY_TECHNICAL_ERROR}</Typography>
    </Alert>
  </div>
);

export default TechnicalErrorAlert;
